import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import type Mithril from 'mithril';
import type Article from '../models/Article';

interface LiteraryWorkPageOrderButtonAttrs {
	article: Article;
}

export default class LiteraryWorkPageOrderButton extends Component<LiteraryWorkPageOrderButtonAttrs> {
	article!: Article;

	oninit(vnode: Mithril.Vnode<LiteraryWorkPageOrderButtonAttrs, this>) {
		super.oninit(vnode);
		this.article = this.attrs.article;
	}

	view(): Mithril.Children {
		if (this.article.isAvailable() && this.article.shopLink()) {
			const brandName = app.forum.attribute('orellthalia_brandName');
			const isThalia = app.forum.attribute('isThalia');

			return (
				<div className="WorkArticleOrderButtonContainer">
					<span className="WorkArticleOrderButtonIntro">{app.translator.trans('glowingblue-orell-articles.forum.work.order_on')}</span>
					<Link className="Button WorkArticleOrderButton" target="_blank" href={this.article.shopLink()}>
						<span className="WorkArticleOrderButtonLabel sr-only">{brandName}</span>
					</Link>
					{isThalia && [
						<Link
							className="Button WorkArticleOrderButton WorkArticleOrderButton--thalia-at"
							target="_blank"
							href={`${app.translator.trans('glowingblue-orell-articles.forum.work.thalia_at_link')}${this.article.attribute('productId')}`}
						>
							<span className="WorkArticleOrderButtonLabel sr-only">{app.translator.trans('glowingblue-orell-articles.forum.work.thalia_at')}</span>
						</Link>,
						<Link
							className="Button WorkArticleOrderButton WorkArticleOrderButton--osiander"
							target="_blank"
							href={`${app.translator.trans('glowingblue-orell-articles.forum.work.osiander_link')}${this.article.attribute('productId')}`}
						>
							<span className="WorkArticleOrderButtonLabel sr-only">{app.translator.trans('glowingblue-orell-articles.forum.work.osiander')}</span>
						</Link>,
					]}
				</div>
			);
		} else {
			return null;
		}
	}
}
